import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import {
  FormSubmitButton,
  FormTextInput,
  FormTextAreaInput,
  NavigateLinks,
  FormSelectInput,
} from '@/components';
import { officeSchema, OfficeSchema, defaultValues } from '../../models';
import { createOfficeBreadcrumbs } from '../../config';
import { useOfficesActions, useCitiesOptions } from '../../hooks';
import { zodResolver } from '@hookform/resolvers/zod';

const CreateOffice = () => {
  const navigate = useNavigate();
  const { handleSubmit, control, reset } = useForm<OfficeSchema>({
    resolver: zodResolver(officeSchema),
    defaultValues,
  });

  const breadcrumbs = useMemo(() => createOfficeBreadcrumbs(navigate), []);

  const { onCreateOffice, isCreatingOffice } = useOfficesActions();

  const { options } = useCitiesOptions();

  const onSubmit = async (data: OfficeSchema) => {
    await onCreateOffice(data, reset);
  };

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks actualPage='Crear oficina' breadcrumbs={breadcrumbs} />
      <form
        className='flex flex-col gap-5 bg-white p-12 rounded-lg shadow-md mx-auto max-w-[700px] w-full'
        onSubmit={handleSubmit(onSubmit)}
      >
        <h2 className='text-2xl font-bold select-none'>Crear oficina</h2>
        <div className='flex flex-col gap-4'>
          <FormSelectInput
            name='cityId'
            placeholder='Ciudad'
            control={control}
            options={options}
            required
            autoFocus
          />
          <FormTextInput
            name='address'
            placeholder='Dirección'
            control={control}
            required
          />
          <FormTextInput
            name='name'
            placeholder='Nombre'
            control={control}
            required
          />
          <FormTextAreaInput
            name='description'
            placeholder='Descripción'
            control={control}
            rows={2}
          />
        </div>
        <FormSubmitButton
          isLoading={isCreatingOffice}
          label='Crear'
          icon={' '}
          action={handleSubmit(onSubmit)}
        ></FormSubmitButton>
      </form>
    </section>
  );
};

export default CreateOffice;
